import React, { useEffect, useMemo, useState } from 'react'

import { Header } from 'components/Common'
import { StyledGlobalLayout } from './GlobalLayout.style'

import LayoutPageProperties from 'settings/routes/types/LayoutPageProperties'
import { isMobileDevice } from 'utils'

interface IGlobalLayout extends LayoutPageProperties {
  fixedHeader?: boolean
}

const GlobalLayout = (props: IGlobalLayout) => {
  const { Component, route, fixedHeader = true } = props

  const [isOpenMobileWarning, setIsOpenMobileWarning] = useState(false)

  const showMobileWarning = useMemo(() => {
    const mobileWarningHidden = JSON.parse(localStorage.getItem('mobileWarningHidden') || 'false')
    return !mobileWarningHidden && isMobileDevice
  }, [isMobileDevice, isOpenMobileWarning])

  useEffect(() => {
    setIsOpenMobileWarning(showMobileWarning)
  }, [showMobileWarning])

  return (
    <StyledGlobalLayout fixedHeader={fixedHeader}>
      <Header fixedHeader={fixedHeader} />
      <Component route={route} />
    </StyledGlobalLayout>
  )
}

export default GlobalLayout
